import React from 'react';

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  Icons,
} from '@commenda/kakashi';

interface IndirectTaxTaskAccordionProps {
  pendingCount: number;
  totalCount: number;
  defaultOpen?: boolean;
  emptyStateMessage?: string;
  children: React.ReactNode;
}

export function IndirectTaxTaskAccordion({
  pendingCount,
  totalCount,
  defaultOpen,
  emptyStateMessage = "Looks like you don't have any pending tasks.",
  children,
}: IndirectTaxTaskAccordionProps) {
  const hasPendingTasks = pendingCount > 0;
  const allCompleted = totalCount > 0 && pendingCount === 0;
  const hasNoTasks = totalCount === 0;

  return (
    <Accordion
      type="single"
      collapsible
      defaultValue={defaultOpen ? 'tasks' : undefined}
      className='border-t border-border-primary mb-3xl'
    >
      <AccordionItem
        value="tasks"
        className="border-b border-border-primary bg-transparent"
      >
        <AccordionTrigger className="!p-3xl" hideTriggerIcon>
          <span className="txt-medium-bold text-text-primary">Your tasks</span>

          <div className="flex items-center gap-sm">
            {hasPendingTasks && (
              <span className="txt-extra-small-medium text-text-primary">
                You have {pendingCount} pending task
                {pendingCount > 1 ? 's' : ''}
              </span>
            )}
            {allCompleted && (
              <div className="flex items-center gap-md">
                <Icons.CheckCircle className="size-4 text-text-success" />
                <span className="txt-extra-small-medium text-text-primary">
                  All tasks completed.
                </span>
              </div>
            )}
            {hasNoTasks && (
              <span className="txt-extra-small-medium text-text-tertiary">
                No pending tasks
              </span>
            )}
            <Icons.ChevronDown className="size-4 shrink-0 text-text-tertiary transition-transform duration-200" />
          </div>
        </AccordionTrigger>

        <AccordionContent className="flex flex-col gap-lg px-3xl pb-3xl">
          {hasPendingTasks ? (
            children
          ) : (
            <span className="txt-small-regular text-text-tertiary">
              {emptyStateMessage}
            </span>
          )}
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
}
